import twemoji from '@twemoji/api'

import emojiData, { emojiGroupData } from '@/utils/emojiData.js'

export const emojiNames = Object.keys(emojiData)

export const emojiNamesWithAliases = [...emojiNames]

const emojis = {}
export const emojisWithAliases = {}

export const emojiAliases = {}

export const emojiGroups = [...emojiGroupData]

for (const name of emojiNames) {
  const [emoji, aliases, group] = emojiData[name]
  emojis[name] = emoji
  emojisWithAliases[name] = emoji
  if (aliases) {
    for (const alias of aliases.split(' ')) {
      emojiAliases[alias] = name
      emojisWithAliases[alias] = emoji
      emojiNamesWithAliases.push(alias)
    }
  }
  if (group !== undefined) {
    emojiGroups[group].emojis.push(name)
  }
}

export function getEmoji (name) {
  if (name in emojis) {
    return emojis[name]
  }
  if (name in emojiAliases) {
    return emojis[emojiAliases[name]]
  }
}

export function getNormalizedEmojiName (name) {
  if (name in emojis) {
    return name
  }
  if (name in emojiAliases) {
    return emojiAliases[name]
  }
}

const U200D = String.fromCharCode(0x200D)
const UFE0Fg = /\uFE0F/g

/**
 * Gets the image URL for a given emoji
 * Borrowed/stolen from twemoji lib
 */
export function getEmojiImageUrl (name) {
  let emojiText = getEmoji(name)
  if (!emojiText) throw new Error(`invalid emoji ${name}`)

  // See https://github.com/jdecked/twemoji/issues/151
  if (emojiText === '\u{1f441}\u{fe0f}\u{200d}\u{1f5e8}\u{fe0f}') {
    emojiText = '\u{1F441}\u{200D}\u{1F5E8}'
  }
  const codePoint = twemoji.convert.toCodePoint(emojiText.indexOf(U200D) < 0
    ? emojiText.replace(UFE0Fg, '')
    : emojiText,
  )
  return ''.concat(twemoji.base, twemoji.size, '/', codePoint, twemoji.ext)
}

export const commonEmojiNames = [
  'carrot',
  'red_heart',
  'green_heart',
  'hundred_points',
  'face_with_open_mouth',
  'crying_face',
  'grinning_squinting_face',
  'partying_face',
  'rolling_on_the_floor_laughing',
  'star_struck',
  'thumbs_up',
  'eyes',
  'raising_hands',
  'waving_hand',
  'seedling',
]

export default emojis
